import React from 'react';

const CustomHeader = () => (
    <div style={{ textAlign: 'center' }}>
      <strong>Ventas por Cuenta Propia</strong>
    </div>
  );
  
export const columnsTable = () => [
    
    {
      name: 'Del No.',
      selector: row => row.delNo,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Fecha de Emisión',
      selector: row => row.dia,
      sortable: true,
      width: '160px',
    },
    {
      name: 'No. Correlativo',
      selector: row => row.alNo,
      sortable: true,
      width: '160px',
    },
    {
      name: 'Prefijo o serie',
      selector: row => row.maquina,
      sortable: true,
      width: '160px',
    },
    {
      name: 'No. Control Interno Sistema Formulario Único',
      selector: row => row.noSujetas,
      sortable: true,
      width: '350px',
    },
    {
      name: 'Nombre del Cliente, Mandante o Mandatario',
      selector: row => row.exentas,
      sortable: true,
      width: '350px',
    },
    {
      name: 'NRC',
      selector: row => row.gravadas,
      sortable: true,
      width: '80px',
    },
    {
      name: 'No Sujetas',
      selector: row => row.exportaciones,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Exentas',
      selector: row => row.ventasTotales,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Interinas Gravadas',
      selector: row => row.terceros,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Débito Fiscal',
      selector: row => row.retencion,
      sortable: true,
      width: '150px',
    },
    {
      name: 'No Sujetas (Terceros)',
      selector: row => row.exportaciones,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Exentas (Terceros)',
      selector: row => row.ventasTotales,
      sortable: true,
      width: '180px',
    },
    {
      name: 'Interinas Gravadas (Terceros)',
      selector: row => row.terceros,
      sortable: true,
      width: '250px',
    },
    {
      name: 'Débito Fiscal (Terceros)',
      selector: row => row.retencion,
      sortable: true,
      width: '200px',
    },
    {
      name: 'IVA Retenido',
      selector: row => row.retencion,
      sortable: true,
      width: '150px',
    },
  ];